import schedule from '../../schedule/schedule'
import Graduations from '../../graduations/graduations'
import Specializations from '../../specializations/specialization'

export default {
  schedule,
  Graduations,
  Specializations
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company-professional/components/Items/resources/components.js